/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  CreateIntegratorUserOptions,
  CreateIntegratorUserResponses,
} from '../types/CreateIntegratorUser'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Create a new user
 * {@link /v1/integrators/user}
 */
export function createIntegratorUser<ThrowOnError extends boolean = true>(
  options: Options<CreateIntegratorUserOptions, ThrowOnError>,
): Unwrappable<RequestResult<CreateIntegratorUserResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'POST',
      url: '/v1/integrators/user',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<CreateIntegratorUserResponses, ThrowOnError>>,
  )
}
